import get from 'lodash/get';

const storeVariables = ['name'];
const contactVariables = ['first_name', 'last_name'];
export function replaceVariables(text, store, contact) {
  if(!text) return text;
  storeVariables.forEach((variable) => {
    text = text
      .split(`{{ store.${variable} }}`)
      .join(get(store, variable, null) != null ? store[variable] : '');
  });
  contactVariables.forEach((variable) => {
    text = text
      .split(`{{ contact.${variable} }}`)
      .join(get(contact, variable, null) != null ? contact[variable] : '');
  });

  return text;
}
